"use strict";

import { Collection } from "Collection";
import { FormButtonsModel } from 'Models/FormButtonsModel';
import { Objects } from "Constants/objects";
export var FormButtonsCollection = Collection.extend({
  model: FormButtonsModel,
  object: Objects.SysFormButtons
});